module.exports = __webpack_public_path__ + "static/img-pharmacists-school-4cb14f6658e8aa430052846c2329937d.jpg";